import React, { useState } from 'react';
import { Sidebar } from '../components/sidebar/Sidebar';
import { Navbar } from '../components/navbar/Navbar';
import { BottomNavigation } from "../components/bottom-navigation/BottomNavigation";

export function Layout({ children, activeTab = 'dashboard', onTabChange }) {


  const usuario = JSON.parse(
    localStorage.getItem("usuario")
  );


  const profileName = usuario?.nome || "Usuário";


  return (
    <div className="min-h-screen bg-background flex text-text-primary">
      {/* Desktop Sidebar (hidden on mobile) */}
      <div className="hidden md:block shrink-0">
        <Sidebar active={activeTab} onChange={onTabChange} />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 pb-16 md:pb-0">
        {/* Header / Navbar */}
        <Navbar profileName={profileName} />
        
        {/* Viewport Content */}
        <main className="flex-1 p-6 md:p-8 max-w-7xl w-full mx-auto overflow-y-auto">
          {children}
        </main>
      </div>

      {/* Mobile Bottom Navigation (hidden on desktop) */}
      <BottomNavigation active={activeTab} onChange={onTabChange} />
    </div>
  );
}
